import { render, staticRenderFns } from "./IntegrationPrometheus.vue?vue&type=template&id=2df5736e&scoped=true"
import script from "./IntegrationPrometheus.vue?vue&type=script&lang=js"
export * from "./IntegrationPrometheus.vue?vue&type=script&lang=js"
import style0 from "./IntegrationPrometheus.vue?vue&type=style&index=0&id=2df5736e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df5736e",
  null
  
)

export default component.exports